import React from 'react'
import { Redirect } from 'react-router-dom'

import dashboardRoutes from './views/Temp/DashboardRoutes'
import TemplateRoutes from './views/TempleteReference/TemplateRoutes'
import HotelRegRoute from './views/HotelRegistration/HotelRegRoute'
import AdminDataSetupRoute from './views/Admin/AdminDataSetupRoute'
import HotelOwnerRoute from './views/Hotel_Owner/HotelOwnerRoute'
import CommonRoutes from './views/Common_pages/CommonRoutes'
import AgentRountes from './views/Agent/AgentRoute'
const redirectRoute = [
    {
        path: '/',
        exact: true,
        component: () => <Redirect to="/dashboard" />,
    },
]

const errorRoute = [
    {
        component: () => <Redirect to="/session/404" />,
    },
]

const routes = [
    ...dashboardRoutes,
    ...TemplateRoutes,
    ...redirectRoute,
    ...HotelRegRoute,
    ...AdminDataSetupRoute,
    ...HotelOwnerRoute,
    ...CommonRoutes,
    ...AgentRountes,
   
    ...errorRoute
]

export default routes
